import script from "./RubricaTablaOpinion.vue?vue&type=script&lang=ts&setup=true"
export * from "./RubricaTablaOpinion.vue?vue&type=script&lang=ts&setup=true"

import "./RubricaTablaOpinion.vue?vue&type=style&index=0&id=237fe724&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-237fe724"]])

export default __exports__